import React from "react";
import SEO from "../components/SEO";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <SEO
        title="Terms and Conditions | 100Eyes Technologies LLP."
        description="Read the Terms and Conditions of 100Eyes Technologies LLP for using our services and website."
        canonical="https://100eyestechnologies.com/terms-and-conditions"
      />

      <div className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-blue-700 mb-6">Terms and Conditions</h1>
        <p className="mb-4 text-sm text-gray-500">
          Effective Date: {new Date().toLocaleDateString()}
        </p>

        <p className="mb-6">
          Welcome to <strong>100Eyes Technologies LLP</strong> By accessing our website or engaging in our
          services, you agree to the terms and conditions outlined below.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">1. Services</h2>
        <p className="mb-4">
          We provide software development, web design, digital transformation, and related IT services as defined
          in our respective Service Agreements or Statements of Work (SOW).
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">2. Payments</h2>
        <p className="mb-4">
          All payments must be made according to the milestones or schedules defined in your service agreement.
          Late payments may incur penalties as mentioned therein.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">3. Intellectual Property</h2>
        <p className="mb-4">
          All intellectual property rights related to code, design, or deliverables produced by 100Eyes
          Technologies remain the exclusive property of the company unless otherwise stated in writing.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">4. Confidentiality</h2>
        <p className="mb-4">
          Both parties agree to maintain confidentiality of all proprietary or sensitive information shared
          during the course of the project.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">5. Limitation of Liability</h2>
        <p className="mb-4">
          100Eyes Technologies shall not be liable for indirect or consequential damages. Our total liability
          shall not exceed the total project fees paid by the client.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">6. Data Protection</h2>
        <p className="mb-4">
          We handle customer data strictly in accordance with our{" "}
          <a href="/privacy-policy" className="text-blue-600 underline">
            Privacy Policy
          </a>
          . No data is shared with third parties or sister concerns.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">7. Termination</h2>
        <p className="mb-4">
          We reserve the right to terminate services immediately in the event of non-payment, breach of terms, or
          misuse of our intellectual property.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">8. Governing Law</h2>
        <p>
          These terms are governed by the laws of India. Any disputes shall be subject to the exclusive
          jurisdiction of the courts of Delhi.
        </p>
      </div>
    </div>
  );
}
